
import { sendPost } from '../http.js'
const api = {
	'messageScroll': {//首页轮播展示信息 
        url: '/site/message/scroll',
		mutationsName: 'mutationsMessageScroll',
		stateName: 'stateMessageScroll',
    },
	'messageUnreadyNumber': {//未读消息数
	    url: '/site/message/unready/number',
		mutationsName: 'mutationsMessageUnreadyNumber',
		stateName: 'stateMessageUnreadyNumber',
	},
	'messageUnready': {//未读消息列表
	    url: '/site/message/unready',
		mutationsName: 'mutationsMessageUnready',
		stateName: 'stateMessageUnready',
	},
	'messageIndex': {//全部消息列表
	    url: '/site/message/index',
		mutationsName: 'mutationsMessageIndex',
		stateName: 'stateMessageIndex',
	},
	'messageInfo': {// 消息详情
	    url: '/site/message/info'
	},
	'messageReady': {//标记已读（单个消息）
	    url: '/site/message/ready',
		mutationsName: 'mutationsMessageReady',
		stateName: 'stateMessageReady',
	},
	'messageReadyAll': {//标记已读（所有未读）
	    url: '/site/message/ready/all',
		mutationsName: 'mutationsMessageReadyAll',
		stateName: 'stateMessageReadyAll',
	},
	'confirmmessage': {
		url: '/site/message/confirmmessage'
	},
	// 短信服务
	'smsindex': {
		url: '/user/user/smsindex'
	},
	'smslist': {
		url: '/user/user/smslist'
	},
	'payPrepayurl': {
		url: '/pay/prepayurl'
	},
	'payCheckorder': {
		url: '/pay/checkorder'
	},
	'smsactivity': {
		url: '/user/user/smsactivity'
	},
	'platform': {
		url: '/user/user/platform'
	},
	'priveEditsms':{
		url:'/user/user/private/sms'
	},
	'audiosms':{
		url:'/user/user/audio/sms'
	},
	'delaudiosms':{
		url:'/user/user/rm/audio/sms'
	},
	'orderclue':{
		url:'/user/order/clue'
	},
	'orderclueV2':{ // 线索管理页查询列表接口v2
		url:'/user/order/v2/clue'
	},
	'ordercluedetail':{ //线索详情
		url: '/user/order/clue/details'
	},
	'getInteractionLogAPI':{ // 获取互动记录
		url: '/user/order/clue_interaction_log'
	},
	'editorderclue':{ // 修改线索订单备注
		url:'/user/order/clue/set'
	},
	'getPrivateStatisticsListAPI':{ // 获取转私统计列表
		url:'/statistics/private/sms/statistics'
	},
	'getClassListAPI':{ // 获取转私统计课程列表
		url:'/author/course/get_course_with_channel'
	},
	'authorcourse':{
		url:'/author/course/index '
	},
	'smsproduct':{
		url:'/author/sms_product'
	},
	'smsproductV2API':{
		url:'/author/sms_product/v2' // v2
	},
	'smsproductadd':{
		url:'/author/sms_product/add/v2'
	},
	'smsproductdel':{
		url:'/author/sms_product/del'
	},
	'smsproductnopage':{
		url:'/author/sms_product/nopage'
	},
	'smsordercluesmssend':{ // 原来的发送短信
		url:'/user/order/clue_sms_send' 
	},
	'smsordercluesmssendbatch':{ // 批量发送短信
		url:'/user/order/clue_sms_send/batch' 
	},
	'smsordercluesmssendbatchV2':{ // 批量发送短信v2
		url:'/user/order/v2/clue_sms_send/batch' 
	},
	'getMessageLackAPI':{ // 短信服务是否不足
		url:'/user/user/smschecksurplus' 
	},
	'changeCodeAPI':{ // 变更二维码
		url:'/user/order/clue/change_code' 
	},
	'changeCodeV2API':{ // 变更二维码v2
		url:'/user/order/v2/clue/change_code' 
	},
	'getCanChangedCodeListAPI':{ // 获取可变更二维码列表
		url:'/user/user/private/sms/list' 
	},
	'clueCallHimAPI':{ // 语音呼叫未建联线索
		url:'/user/order/clue_audio_sms_send' 
	},
	waitCount: {
		url: 'user/order/wait_count',
		mutationsName: 'changeWaitCount',
		stateName: 'waitCountObj',
		stateDefaultName: {}
	},
	privateQrcode: {
		url: '/user/user/sms/private/qrcode',
		method: 'get'
	},
	toggleMessageStatus:{
		url: '/user/user/sms/private/qrcode/used',
		method: 'post'
	},
	'changeMessageModeAPI': { // 修改短信服务模式 平台默认/企微模式
		url: '/wework/update_wework_mod'
	},
	'getWeworkKefuInfoAPI': { // 获取企微客服信息
		url: '/wework/kefu_info'
	},
	'uploadFileToWxAPI': { // 上传微信素材
		url: '/wework/media_upload'
	},
	'setWeworkInfoAPI': { // 设置企微客服信息
		url: '/wework/kefu_set'
	},
	'getWeworkAuthStatusAPI': { // 获取企微授权状态和二维码
		url: '/wework/auth_status'
	}
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params, method='post', headers) => {
            return sendPost(api[key].url, params, api[key].method || method, headers)
        }
    } 
}
export default requestFunObj
